import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Avatar from './Avatar';
import { listContacts } from '../api/contacts';
import type { UserBriefDto } from '../api/types';
import { filterContacts } from '../lib/contactReference';
import { backdropClose } from '../lib/modalBackdrop';

interface Props {
  onClose: () => void;
  onPick: (contact: UserBriefDto) => void;
}

/** Выбор контакта для отправки в чат (пункт «Контакт» меню вложений). */
export default function ContactPickerModal({ onClose, onPick }: Props) {
  const { t } = useTranslation('chatView');
  const [contacts, setContacts] = useState<UserBriefDto[] | null>(null);
  const [failed, setFailed] = useState(false);
  const [query, setQuery] = useState('');

  useEffect(() => {
    let alive = true;
    listContacts()
      .then((list) => alive && setContacts(list))
      .catch(() => alive && setFailed(true));
    return () => {
      alive = false;
    };
  }, []);

  const filtered = filterContacts(contacts ?? [], query);

  return (
    <div className="modal-backdrop" {...backdropClose(onClose)}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <h2>{t('attachContact.title')}</h2>
        <input
          type="text"
          autoFocus
          value={query}
          placeholder={t('attachContact.search')}
          onChange={(e) => setQuery(e.target.value)}
        />
        <div className="forward-chat-list">
          {failed ? (
            <div style={{ color: 'var(--danger, #d33)' }}>{t('attachContact.failed')}</div>
          ) : contacts === null ? (
            <div style={{ color: 'var(--muted)' }}>{t('attachContact.loading')}</div>
          ) : filtered.length === 0 ? (
            <div style={{ color: 'var(--muted)' }}>{t('attachContact.empty')}</div>
          ) : (
            filtered.map((u) => (
              <div key={u.id} className="user-row" onClick={() => onPick(u)}>
                <Avatar userId={u.id} name={u.displayName || u.username} size={32} version={u.avatarFileId} />
                <div style={{ flex: 1 }}>
                  {u.displayName || u.username}
                  <div style={{ color: 'var(--muted)', fontSize: 12 }}>@{u.username}</div>
                </div>
              </div>
            ))
          )}
        </div>
        <div className="row" style={{ marginTop: 12, justifyContent: 'flex-end' }}>
          <button className="btn btn-ghost" onClick={onClose}>{t('attachContact.cancel')}</button>
        </div>
      </div>
    </div>
  );
}
